<div class="loader-container">
    <app-loader *ngIf="loading == true"></app-loader>
    <app-modal-header *ngIf="modalStyle === true" [title]="modalTitle"></app-modal-header>
    <div [ngClass]="{ 'modal-body': modalStyle === true }">
        <div *ngIf="errorMessage && errorMessage.length" class="alert alert-danger d-flex align-items-center"
            role="alert">
            <div>{{ errorMessage }}</div>
        </div>

        <div class="row">
            <div class="col-6">
                <div class="mb-3">
                    <label class="form-label">Systeemnaam</label>
                    <input type="text" class="form-control" [(ngModel)]="item.system_name" name="system_name">
                </div>
            </div>

            <div class="col-6">
                <div class="mb-3">
                    <label class="form-label">Roepnaam</label>
                    <input type="text" class="form-control" [(ngModel)]="item.friendly_name" name="friendly_name">
                </div>
            </div>

            <div class="col-6">

                <div class="mb-3">
                    <label class="form-label">Locatie</label>
                    <input type="text" class="form-control" [(ngModel)]="item.location" name="location">
                </div>

                <div class="mb-3">
                    <label class="form-label">Postcode</label>
                    <input type="text" class="form-control" [(ngModel)]="item.postal_code" name="postal_code">
                </div>

                <div class="mb-3">
                    <label class="form-label">Land</label>
                    <input type="text" class="form-control" [(ngModel)]="item.country" name="country">
                </div>

                <div class="mb-3">
                    <label class="form-label">Brin nummer</label>
                    <input type="text" class="form-control" [(ngModel)]="item.brin_number" name="brin_number">
                </div>

                <div class="mb-3">
                    <label class="form-label">Contactpersoon e-mailadres</label>
                    <input type="email" class="form-control" [(ngModel)]="item.contact_email" name="contact_email">
                </div>
            </div>

            <div class="col-6">

                <div class="mb-3">
                    <label class="form-label">Adres</label>
                    <input type="text" class="form-control" [(ngModel)]="item.address" name="address">
                </div>

                <div class="mb-3">
                    <label class="form-label">Plaats</label>
                    <input type="text" class="form-control" [(ngModel)]="item.city" name="city">
                </div>

                <div class="mb-3">
                    <label class="form-label">Regio</label>
                    <select class="form-select" [(ngModel)]="item.region" name="region">
                        <option value="">Selecteer regio</option>
                        <option *ngFor="let region of regions" [value]="region">{{ region }}</option>
                    </select>
                </div>

                <div class="mb-3">
                    <label class="form-label">Bevoegd gezag-nummer</label>
                    <input type="text" class="form-control" [(ngModel)]="item.authority_number" name="authority_number">
                </div>

                <div class="mb-3">
                    <label class="form-label">Vestigingsnummer</label>
                    <input type="text" class="form-control" [(ngModel)]="item.department_number"
                        name="department_number">
                </div>
            </div>

            <div class="col-6">
                <div class="mb-3">
                    <label class="form-label">OIE CODE</label>
                    <input type="text" class="form-control" [(ngModel)]="item.oie_code" name="oie_code">
                </div>

                <div class="mb-3">
                    <label class="form-label">BasispoortId</label>
                    <input type="text" class="form-control" [(ngModel)]="item.bp_id" name="bp_id">
                </div>
            </div>
            <div class="col-6">
                <div class="mb-3">
                    <label class="form-label">DigiDeliveryId</label>
                    <input type="text" class="form-control" [(ngModel)]="item.dd_id" name="dd_id">
                </div>

                <div class="mb-3">
                    <label class="form-label">LAS-key</label>
                    <input type="text" class="form-control" [(ngModel)]="item.as_id" name="as_id">
                </div>
            </div>
        </div>
        <div class="col-12">
            <div class="card p-3">
                <h6 class="fw-bold">Voorwaarden</h6>
                <div class="form-check">
                    <input id="terms_and_conditions_accepted" class="form-check-input" type="checkbox"
                        [(ngModel)]="item.terms_and_conditions_accepted" name="terms_and_conditions_accepted">
                    <label for="terms_and_conditions_accepted" class="form-check-label">Algemeen</label>
                </div>

                <div class="form-check">
                    <input id="privacy_agreement_accepted" class="form-check-input"
                        [(ngModel)]="item.privacy_agreement_accepted" type="checkbox" name="privacy_agreement_accepted">
                    <label for="privacy_agreement_accepted" class="form-check-label">Privacy
                        overeenkomst</label>
                </div>

                <div class="form-check">
                    <input id="processing_agreement_accepted" class="form-check-input"
                        [(ngModel)]="item.processing_agreement_accepted" type="checkbox"
                        name="processing_agreement_accepted">
                    <label for="processing_agreement_accepted" class="form-check-label">Verwerkings
                        overeenkomst</label>
                </div>
            </div>
        </div>

        <div class="form-buttons">
            <button type="button" class="btn btn-primary" (click)="save()">Opslaan</button>
        </div>
    </div>
</div>